var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1078 230.4h-956.02c-50.73 0-91.992 41.266-91.992 91.984v555.23c0 50.719 41.262 91.984 91.988 91.984h956.02c50.727 0 91.988-41.262 91.988-91.984l0.003906-555.23c0-50.719-41.262-91.984-91.988-91.984zm-17.09 52.555-406.52 286.05c-32.543 22.902-76.273 22.902-108.82 0l-406.51-286.05zm-977.55 602.66c-0.53516-2.582-0.81641-5.2578-0.81641-8v-555.23c0-4.6641 0.81641-9.1445 2.3125-13.301l337.75 237.66zm42.918 31.43 339.97-339.59 49.078 34.535c25.32 17.812 54.984 26.723 84.66 26.723 29.664 0 59.34-8.9141 84.66-26.727l49.078-34.535 339.97 339.59zm991.16-39.43c0 2.7422-0.28125 5.418-0.81641 8l-339.25-338.86 337.75-237.66c1.4922 4.1562 2.3125 8.6367 2.3125 13.301z",
    fill: "#1e263f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.2022036458d0f5a96cf972bb11296636.svg";
export { ForwardRef as ReactComponent };